import Image from 'next/image'
import { useEffect, useLayoutEffect, useState } from 'react'
import { isMobile, isTablet } from 'react-device-detect'
import { useTranslation } from 'react-i18next'
import { FCC } from '~/core/@types/global'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from '~/core/ui/Accordion'
import { TypographyText } from '~/core/ui/Text'
import { cn } from '~/core/ui/utils'
import LPContainer from './LPContainer'
import dynamic from 'next/dynamic'
import Slider from 'react-slick'

// react-slick cần chạy phía client, tắt SSR để tránh lỗi window khi render server
const SlickSlider = Slider as unknown as React.FC<any>

const AllFeatureSection: FCC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation()
  const [value, setValueChange] = useState(`item-0`)
  const [arrowState, setArrowState] = useState({
    arrowTitle00: {
      arrowStart: {
        direction: 'top',
        top: 0,
        left: 0,
        height: 0,
        marginTop: 0
      },
      arrowLine: { direction: 'top', top: 0, left: 0, height: 0, marginTop: 0 },
      arrowEnd: { direction: 'top', top: 0, left: 0, height: 0, marginTop: 0 }
    },
    arrowTitle01: {
      arrowStart: {
        direction: 'top',
        top: 0,
        left: 0,
        height: 0,
        marginTop: 0
      },
      arrowLine: { direction: 'top', top: 0, left: 0, height: 0, marginTop: 0 },
      arrowEnd: { direction: 'top', top: 0, left: 0, height: 0, marginTop: 0 }
    },
    arrowTitle02: {
      arrowStart: {
        direction: 'bottom',
        top: 0,
        left: 0,
        height: 0,
        marginTop: 0
      },
      arrowLine: {
        direction: 'bottom',
        top: 0,
        left: 0,
        height: 0,
        marginTop: 0
      },
      arrowEnd: {
        direction: 'bottom',
        top: 0,
        left: 0,
        height: 0,
        marginTop: 0
      }
    },
    arrowTitle03: {
      arrowStart: {
        direction: 'bottom',
        top: 0,
        left: 0,
        height: 0,
        marginTop: 0
      },
      arrowLine: {
        direction: 'bottom',
        top: 0,
        left: 0,
        height: 0,
        marginTop: 0
      },
      arrowEnd: {
        direction: 'bottom',
        top: 0,
        left: 0,
        height: 0,
        marginTop: 0
      }
    }
  })
  const [activeArrowIndex, setActiveArrowIndex] = useState(0)
  const activeIndex = Number(value?.replace('item-', ''))

  useEffect(() => {
    handleCalculateArrow()
  }, [value])

  useEffect(() => {
    window.addEventListener('resize', handleCalculateArrow)
    handleCalculateArrow()
    return () => window.removeEventListener('resize', handleCalculateArrow)
  }, [])

  const handleCalculateArrow = () => {
    setTimeout(() => {
      if (!isMobile || isTablet) {
        const arrowContainer = document
          .getElementById('arrow-container')
          ?.getBoundingClientRect()
        const arrowLineLogo = document
          .getElementById('arrow-line-logo')
          ?.getBoundingClientRect()
        const arrowLogo = document
          .getElementById('arrow-logo')
          ?.getBoundingClientRect()
        const arrowTitle00 = document
          .getElementById('arrow-title-0')
          ?.getBoundingClientRect()
        const arrowTitle01 = document
          .getElementById('arrow-title-1')
          ?.getBoundingClientRect()
        const arrowTitle02 = document
          .getElementById('arrow-title-2')
          ?.getBoundingClientRect()
        const arrowTitle03 = document
          .getElementById('arrow-title-3')
          ?.getBoundingClientRect()

        // console.log('arrowContainer', arrowContainer)
        // console.log('arrowLineLogo', arrowLineLogo)
        // console.log('arrowLogo', arrowLogo)
        // console.log('arrowTitle00', arrowTitle00)
        // console.log('arrowTitle01', arrowTitle01)
        // console.log('arrowTitle02', arrowTitle02)
        // console.log('arrowTitle03', arrowTitle03)

        const arrow00Direction =
          Number(arrowTitle00?.top) > Number(arrowLogo?.top) + 50
            ? 'bottom'
            : 'top'
        const arrow01Direction =
          Number(arrowTitle01?.top) > Number(arrowLogo?.top) + 50
            ? 'bottom'
            : 'top'
        const arrow02Direction =
          Number(arrowTitle02?.top) > Number(arrowLogo?.top) + 50
            ? 'bottom'
            : 'top'
        const arrow03Direction =
          Number(arrowTitle03?.top) > Number(arrowLogo?.top) + 50
            ? 'bottom'
            : 'top'

        setArrowState({
          arrowTitle00: {
            arrowStart: {
              direction: arrow00Direction,
              top: Number(arrowTitle00?.top) - Number(arrowContainer?.top) + 16,
              left:
                Number(arrowTitle00?.right) - Number(arrowContainer?.left) + 60,
              height: 0,
              marginTop: arrow00Direction === 'bottom' ? 22 : 0
            },
            arrowLine: {
              direction: arrow00Direction,
              top:
                arrow00Direction === 'top'
                  ? Number(arrowTitle00?.top) -
                    Number(arrowContainer?.top) +
                    16 +
                    12
                  : Number(arrowLogo?.top) - Number(arrowContainer?.top) + 27,
              left:
                Number(arrowTitle00?.right) -
                Number(arrowContainer?.left) +
                60 +
                50,
              height:
                Number(arrowLogo?.top) - Number(arrowTitle00?.top) > 0
                  ? Number(arrowLogo?.top) - Number(arrowTitle00?.top)
                  : 0,
              marginTop: arrow00Direction === 'bottom' ? 22 : 0
            },
            arrowEnd: {
              direction: arrow00Direction,
              top: Number(arrowLogo?.top) - Number(arrowContainer?.top) + 27,
              left:
                Number(arrowTitle00?.right) -
                Number(arrowContainer?.left) +
                60 +
                50,
              height: 0,
              marginTop: arrow00Direction === 'bottom' ? 22 : 0
            }
          },
          arrowTitle01: {
            arrowStart: {
              direction: arrow01Direction,
              top: Number(arrowTitle01?.top) - Number(arrowContainer?.top) + 16,
              left:
                Number(arrowTitle01?.right) - Number(arrowContainer?.left) + 60,
              height: 0,
              marginTop: arrow01Direction === 'bottom' ? 22 : 0
            },
            arrowLine: {
              direction: arrow01Direction,
              top:
                arrow01Direction === 'top'
                  ? Number(arrowTitle01?.top) -
                    Number(arrowContainer?.top) +
                    16 +
                    12
                  : Number(arrowLogo?.top) - Number(arrowContainer?.top) + 27,
              left:
                Number(arrowTitle01?.right) -
                Number(arrowContainer?.left) +
                60 +
                50,
              height:
                arrow01Direction === 'top'
                  ? Number(arrowLogo?.top) - Number(arrowTitle01?.top) > 0
                    ? Number(arrowLogo?.top) - Number(arrowTitle01?.top)
                    : 0
                  : Number(arrowTitle01?.top) -
                    Number(arrowLogo?.top) -
                    50 -
                    12,
              marginTop: arrow01Direction === 'bottom' ? 22 : 0
            },
            arrowEnd: {
              direction: arrow01Direction,
              top: Number(arrowLogo?.top) - Number(arrowContainer?.top) + 27,
              left:
                Number(arrowTitle01?.right) -
                Number(arrowContainer?.left) +
                60 +
                50,
              height: 0,
              marginTop: arrow01Direction === 'bottom' ? 22 : 0
            }
          },
          arrowTitle02: {
            arrowStart: {
              direction: arrow02Direction,
              top: Number(arrowTitle02?.top) - Number(arrowContainer?.top) + 16,
              left:
                Number(arrowTitle02?.right) - Number(arrowContainer?.left) + 60,
              height: 0,
              marginTop: arrow02Direction === 'bottom' ? 22 : 0
            },
            arrowLine: {
              direction: arrow02Direction,
              top:
                arrow02Direction === 'top'
                  ? Number(arrowTitle02?.top) -
                    Number(arrowContainer?.top) +
                    16 +
                    12
                  : Number(arrowLogo?.top) - Number(arrowContainer?.top) + 27,
              left:
                Number(arrowTitle02?.right) -
                Number(arrowContainer?.left) +
                60 +
                50,
              height:
                arrow02Direction === 'top'
                  ? Number(arrowLogo?.top) - Number(arrowTitle02?.top) > 0
                    ? Number(arrowLogo?.top) - Number(arrowTitle02?.top)
                    : 0
                  : Number(arrowTitle02?.top) -
                    Number(arrowLogo?.top) -
                    50 -
                    12,
              marginTop: arrow02Direction === 'bottom' ? 22 : 0
            },
            arrowEnd: {
              direction: arrow02Direction,
              top: Number(arrowLogo?.top) - Number(arrowContainer?.top) + 27,
              left:
                Number(arrowTitle02?.right) -
                Number(arrowContainer?.left) +
                60 +
                50,
              height: 0,
              marginTop: arrow02Direction === 'bottom' ? 22 : 0
            }
          },
          arrowTitle03: {
            arrowStart: {
              direction: arrow03Direction,
              top: Number(arrowTitle03?.top) - Number(arrowContainer?.top) + 16,
              left:
                Number(arrowTitle03?.right) - Number(arrowContainer?.left) + 60,
              height: 0,
              marginTop: arrow03Direction === 'bottom' ? 22 : 0
            },
            arrowLine: {
              direction: arrow03Direction,
              top:
                arrow03Direction === 'top'
                  ? Number(arrowTitle03?.top) -
                    Number(arrowContainer?.top) +
                    16 +
                    12
                  : Number(arrowLogo?.top) - Number(arrowContainer?.top) + 27,
              left:
                Number(arrowTitle03?.right) -
                Number(arrowContainer?.left) +
                60 +
                50,
              height:
                arrow03Direction === 'top'
                  ? Number(arrowLogo?.top) - Number(arrowTitle03?.top) > 0
                    ? Number(arrowLogo?.top) - Number(arrowTitle03?.top)
                    : 0
                  : Number(arrowTitle03?.top) -
                    Number(arrowLogo?.top) -
                    50 -
                    12,
              marginTop: arrow03Direction === 'bottom' ? 22 : 0
            },
            arrowEnd: {
              direction: arrow03Direction,
              top: Number(arrowLogo?.top) - Number(arrowContainer?.top) + 27,
              left:
                Number(arrowTitle03?.right) -
                Number(arrowContainer?.left) +
                60 +
                50,
              height: 0,
              marginTop: arrow03Direction === 'bottom' ? 22 : 0
            }
          }
        })
        setActiveArrowIndex(Number(value?.replace('item-', '')))
      }
    }, 300)
  }
  console.log(arrowState)

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplaySpeed: 5000,
    autoplay: false,
    focusOnSelect: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: 'slick-dots'
  }

  const SECTIONS = [
    {
      contentTitle: t('lp:all_feature_section:section_1_content_title'),
      contentDescription: t(
        'lp:all_feature_section:section_1_content_description'
      ),
      contentImageTitle: t(
        'lp:all_feature_section:section_1_content_image_title'
      ),
      contentImage: '/img/feature/lp/new/feature01.png',
      contentImageMobile: '/img/feature/lp/new/feature01-mobile.png',
      contentLink: '#'
    },
    {
      contentTitle: t('lp:all_feature_section:section_2_content_title'),
      contentDescription: t(
        'lp:all_feature_section:section_2_content_description'
      ),
      contentImageTitle: t(
        'lp:all_feature_section:section_2_content_image_title'
      ),
      contentImage: '/img/feature/lp/new/feature02.png',
      contentImageMobile: '/img/feature/lp/new/feature02-mobile.png',
      contentLink: '#'
    },
    {
      contentTitle: t('lp:all_feature_section:section_3_content_title'),
      contentDescription: t(
        'lp:all_feature_section:section_3_content_description'
      ),
      contentImageTitle: t(
        'lp:all_feature_section:section_3_content_image_title'
      ),
      contentImage: '/img/feature/lp/new/feature03.png',
      contentImageMobile: '/img/feature/lp/new/feature03-mobile.png',
      contentLink: '#'
    },
    {
      contentTitle: t('lp:all_feature_section:section_4_content_title'),
      contentDescription: t(
        'lp:all_feature_section:section_4_content_description'
      ),
      contentImageTitle: t(
        'lp:all_feature_section:section_4_content_image_title'
      ),
      contentImage: '/img/feature/lp/new/feature04.png',
      contentImageMobile: '/img/feature/lp/new/feature04-mobile.png',
      contentLink: '#'
    }
  ]

  return (
    <div className={cn('relative', className)}>
      <LPContainer>
        {!isMobile || isTablet ? (
          <div
            id="arrow-container"
            className="flex items-center relative h-[525px]">
            <div className="flex-1 pr-[95px]">
              <Accordion
                defaultValue="item-0"
                type="single"
                value={value}
                onValueChange={setValueChange}>
                {SECTIONS?.map((faqItem, index) => {
                  const getItem = `item-${index}`
                  const isSelected = value === getItem
                  const { contentTitle, contentDescription } = faqItem

                  return (
                    <AccordionItem
                      key={index}
                      className={cn(
                        'px-8 py-4',
                        isSelected
                          ? 'border-l-[3px] border-primary-400'
                          : 'border-l border-gray-300'
                      )}
                      value={getItem}>
                      <AccordionTrigger
                        id={`arrow-title-${index}`}
                        className="cursor-pointer">
                        <TypographyText
                          className={cn(
                            'text-[23px] font-medium',
                            isSelected ? 'text-gray-900' : 'text-gray-500'
                          )}>
                          {contentTitle}
                        </TypographyText>
                      </AccordionTrigger>
                      <AccordionContent className="text-base font-normal text-gray-600 mt-2">
                        {contentDescription}
                      </AccordionContent>
                    </AccordionItem>
                  )
                })}
              </Accordion>
            </div>

            <div className="">
              {/* LINE 00 */}
              <div
                id="arrow-line-start-00"
                className={cn(
                  'absolute top-0 h-3 w-[52px]',
                  arrowState.arrowTitle00.arrowStart.top ||
                    arrowState.arrowTitle00.arrowStart.left
                    ? 'block'
                    : 'hidden',
                  activeArrowIndex === 0
                    ? 'border-primary-300 z-20'
                    : 'border-gray-300 z-10',
                  arrowState.arrowTitle00.arrowStart.direction === 'top'
                    ? 'rounded-tr-2xl border-t-2 border-r-2'
                    : 'rounded-br-2xl border-b-2 border-r-2'
                )}
                style={{
                  top: arrowState.arrowTitle00.arrowStart.top,
                  left: arrowState.arrowTitle00.arrowStart.left
                }}
              />
              <div
                id="arrow-line-00"
                className={cn(
                  'absolute top-0 w-0.5',
                  arrowState.arrowTitle00.arrowLine.top ||
                    arrowState.arrowTitle00.arrowLine.left
                    ? 'block'
                    : 'hidden',
                  activeArrowIndex === 0
                    ? 'bg-primary-300 z-20'
                    : 'bg-gray-300 z-10'
                )}
                style={{
                  top: arrowState.arrowTitle00.arrowLine.top,
                  left: arrowState.arrowTitle00.arrowLine.left,
                  height: arrowState.arrowTitle00.arrowLine.height,
                  marginTop: arrowState.arrowTitle00.arrowEnd.marginTop
                }}
              />
              <div
                id="arrow-line-end-00"
                className={cn(
                  'absolute top- h-6 w-6',
                  arrowState.arrowTitle00.arrowEnd.top ||
                    arrowState.arrowTitle00.arrowEnd.left
                    ? 'block'
                    : 'hidden',
                  activeArrowIndex === 0
                    ? 'border-primary-300 z-20'
                    : 'border-gray-300 z-10',
                  arrowState.arrowTitle00.arrowEnd.direction === 'top'
                    ? 'rounded-bl-2xl border-b-2 border-l-2'
                    : 'rounded-tl-2xl border-t-2 border-l-2'
                )}
                style={{
                  top: arrowState.arrowTitle00.arrowEnd.top,
                  left: arrowState.arrowTitle00.arrowEnd.left,
                  marginTop: arrowState.arrowTitle00.arrowEnd.marginTop
                }}
              />
              {/* END LINE 00 */}

              {/* LINE 01 */}
              <div
                id="arrow-line-start-01"
                className={cn(
                  'absolute top-0 h-3 w-[52px]',
                  arrowState.arrowTitle01.arrowStart.top ||
                    arrowState.arrowTitle01.arrowStart.left
                    ? 'block'
                    : 'hidden',
                  activeArrowIndex === 1
                    ? 'border-primary-300 z-20'
                    : 'border-gray-300 z-10',
                  arrowState.arrowTitle01.arrowStart.direction === 'top'
                    ? 'rounded-tr-2xl border-t-2 border-r-2'
                    : 'rounded-br-2xl border-b-2 border-r-2'
                )}
                style={{
                  top: arrowState.arrowTitle01.arrowStart.top,
                  left: arrowState.arrowTitle01.arrowStart.left
                }}
              />
              <div
                id="arrow-line-01"
                className={cn(
                  'absolute top-0 w-0.5',
                  arrowState.arrowTitle01.arrowLine.top ||
                    arrowState.arrowTitle01.arrowLine.left
                    ? 'block'
                    : 'hidden',
                  activeArrowIndex === 1
                    ? 'bg-primary-300 z-20'
                    : 'bg-gray-300 z-10'
                )}
                style={{
                  top: arrowState.arrowTitle01.arrowLine.top,
                  left: arrowState.arrowTitle01.arrowLine.left,
                  height: arrowState.arrowTitle01.arrowLine.height,
                  marginTop: arrowState.arrowTitle01.arrowEnd.marginTop * 2
                }}
              />
              <div
                id="arrow-line-end-01"
                className={cn(
                  'absolute top- h-6 w-6',
                  arrowState.arrowTitle01.arrowEnd.top ||
                    arrowState.arrowTitle01.arrowEnd.left
                    ? 'block'
                    : 'hidden',
                  activeArrowIndex === 1
                    ? 'border-primary-300 z-20'
                    : 'border-gray-300 z-10',
                  arrowState.arrowTitle01.arrowEnd.direction === 'top'
                    ? 'rounded-bl-2xl border-b-2 border-l-2'
                    : 'rounded-tl-2xl border-t-2 border-l-2'
                )}
                style={{
                  top: arrowState.arrowTitle01.arrowEnd.top,
                  left: arrowState.arrowTitle01.arrowEnd.left,
                  marginTop: arrowState.arrowTitle01.arrowEnd.marginTop
                }}
              />
              {/* END LINE 01 */}

              {/* LINE 02 */}
              <div
                id="arrow-line-start-02"
                className={cn(
                  'absolute top-0 h-3 w-[52px]',
                  arrowState.arrowTitle02.arrowStart.top ||
                    arrowState.arrowTitle02.arrowStart.left
                    ? 'block'
                    : 'hidden',
                  activeArrowIndex === 2
                    ? 'border-primary-300 z-20'
                    : 'border-gray-300 z-10',
                  arrowState.arrowTitle02.arrowStart.direction === 'top'
                    ? 'rounded-tr-2xl border-t-2 border-r-2'
                    : 'rounded-br-2xl border-b-2 border-r-2'
                )}
                style={{
                  top: arrowState.arrowTitle02.arrowStart.top,
                  left: arrowState.arrowTitle02.arrowStart.left,
                  marginTop:
                    arrowState.arrowTitle02.arrowStart.direction === 'top'
                      ? 0
                      : -10
                }}
              />
              <div
                id="arrow-line-02"
                className={cn(
                  'absolute top-0 w-0.5',
                  arrowState.arrowTitle02.arrowLine.top ||
                    arrowState.arrowTitle02.arrowLine.left
                    ? 'block'
                    : 'hidden',
                  activeArrowIndex === 2
                    ? 'bg-primary-300 z-20'
                    : 'bg-gray-300 z-10'
                )}
                style={{
                  top: arrowState.arrowTitle02.arrowLine.top,
                  left: arrowState.arrowTitle02.arrowLine.left,
                  height: arrowState.arrowTitle02.arrowLine.height,
                  marginTop: arrowState.arrowTitle02.arrowEnd.marginTop * 2
                }}
              />
              <div
                id="arrow-line-end-02"
                className={cn(
                  'absolute top- h-6 w-6',
                  arrowState.arrowTitle02.arrowEnd.top ||
                    arrowState.arrowTitle02.arrowEnd.left
                    ? 'block'
                    : 'hidden',
                  activeArrowIndex === 2
                    ? 'border-primary-300 z-20'
                    : 'border-gray-300 z-10',
                  arrowState.arrowTitle02.arrowEnd.direction === 'top'
                    ? 'rounded-bl-2xl border-b-2 border-l-2'
                    : 'rounded-tl-2xl border-t-2 border-l-2'
                )}
                style={{
                  top: arrowState.arrowTitle02.arrowEnd.top,
                  left: arrowState.arrowTitle02.arrowEnd.left,
                  marginTop: arrowState.arrowTitle02.arrowEnd.marginTop
                }}
              />
              {/* END LINE 2 */}

              {/* LINE 03 */}
              <div
                id="arrow-line-start-03"
                className={cn(
                  'absolute top-0 h-3 w-[52px]',
                  arrowState.arrowTitle03.arrowStart.top ||
                    arrowState.arrowTitle03.arrowStart.left
                    ? 'block'
                    : 'hidden',
                  activeArrowIndex === 3
                    ? 'border-primary-300 z-20'
                    : 'border-gray-300 z-10',
                  arrowState.arrowTitle03.arrowStart.direction === 'top'
                    ? 'rounded-tr-2xl border-t-2 border-r-2'
                    : 'rounded-br-2xl border-b-2 border-r-2'
                )}
                style={{
                  top: arrowState.arrowTitle03.arrowStart.top,
                  left: arrowState.arrowTitle03.arrowStart.left,
                  marginTop:
                    arrowState.arrowTitle03.arrowStart.direction === 'top'
                      ? 0
                      : -10
                }}
              />
              <div
                id="arrow-line-03"
                className={cn(
                  'absolute top-0 w-0.5',
                  arrowState.arrowTitle03.arrowLine.top ||
                    arrowState.arrowTitle03.arrowLine.left
                    ? 'block'
                    : 'hidden',
                  activeArrowIndex === 3
                    ? 'bg-primary-300 z-20'
                    : 'bg-gray-300 z-10'
                )}
                style={{
                  top: arrowState.arrowTitle03.arrowLine.top,
                  left: arrowState.arrowTitle03.arrowLine.left,
                  height: arrowState.arrowTitle03.arrowLine.height,
                  marginTop: arrowState.arrowTitle03.arrowEnd.marginTop * 2
                }}
              />
              <div
                id="arrow-line-end-03"
                className={cn(
                  'absolute top- h-6 w-6',
                  arrowState.arrowTitle03.arrowEnd.top ||
                    arrowState.arrowTitle03.arrowEnd.left
                    ? 'block'
                    : 'hidden',
                  activeArrowIndex === 3
                    ? 'border-primary-300 z-20'
                    : 'border-gray-300 z-10',
                  arrowState.arrowTitle03.arrowEnd.direction === 'top'
                    ? 'rounded-bl-2xl border-b-2 border-l-2'
                    : 'rounded-tl-2xl border-t-2 border-l-2'
                )}
                style={{
                  top: arrowState.arrowTitle03.arrowEnd.top,
                  left: arrowState.arrowTitle03.arrowEnd.left,
                  marginTop: arrowState.arrowTitle03.arrowEnd.marginTop
                }}
              />
              {/* END LINE 03 */}
            </div>

            <div
              id="arrow-line-logo"
              className="bg-white w-[30px] h-[6px] relative">
              <div className="absolute right-1 top-0.5 bottom-0 h-0.5 w-[26px] bg-primary-300" />
              <div className="absolute right-0 -top-px z-10 w-0 h-0 border-t-[4px] border-t-transparent border-b-[4px] border-b-transparent border-l-[6px] border-l-primary-300" />
            </div>

            <div id="arrow-logo" className="bg-white">
              <Image
                src="/img/feature/lp/new/logo-with-border.png"
                width={100}
                height={100}
                alt="logo for all feature"
                className="h-auto"
              />
            </div>

            <div className="bg-white w-[94px] h-[6px] relative">
              <div className="absolute right-1 top-0.5 bottom-0 h-0.5 w-[90px] bg-primary-300" />
              <div className="absolute right-0 -top-px z-10 w-0 h-0 border-t-[4px] border-t-transparent border-b-[4px] border-b-transparent border-l-[6px] border-l-primary-300" />
            </div>

            <div className="rounded-lg bg-gray-100 p-5">
              <p className="text-lg font-medium text-primary-400 mb-5">
                {SECTIONS[activeIndex].contentImageTitle}
              </p>
              <Image
                src={SECTIONS[activeIndex].contentImage}
                width={424}
                height={0}
                alt={`feature 0${activeIndex}`}
                className="h-auto"
              />
            </div>
          </div>
        ) : (
          <div className="relative">
            <SlickSlider {...settings} className="max-h-[704px]">
              {SECTIONS.map((item, index) => (
                <div
                  key={`screenshot-image-${index}`}
                  className="animate-fadeInUp !border-0 !outline-0">
                  <div>
                    <TypographyText className="text-1.5xl font-medium text-gray-900">
                      {item.contentTitle}
                    </TypographyText>
                    <TypographyText className="text-base font-normal text-gray-700 mt-1.5 mb-2">
                      {item.contentDescription}
                    </TypographyText>
                  </div>

                  <div className="bg-white flex flex-col items-center justify-center relative">
                    <div className="bg-primary-300 w-px h-5" />
                    <Image
                      src="/img/feature/lp/new/logo-with-border.png"
                      width={100}
                      height={100}
                      alt="logo for all feature"
                      className="h-auto"
                    />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="7"
                      height="20"
                      viewBox="0 0 7 20"
                      fill="none">
                      <path
                        d="M3.5 20L6.38675 15L0.613248 15L3.5 20ZM3.5 0L3 -2.18557e-08L3 15.5L3.5 15.5L4 15.5L4 2.18557e-08L3.5 0Z"
                        fill="#838FFB"
                      />
                    </svg>
                  </div>

                  <div className="rounded-lg bg-gray-100 p-5">
                    <p className="text-lg font-medium text-primary-400 mb-5">
                      {item.contentImageTitle}
                    </p>
                    <img
                      src={item.contentImageMobile}
                      alt={`screenshot ${index}`}
                    />
                  </div>
                </div>
              ))}
            </SlickSlider>
          </div>
        )}
      </LPContainer>
    </div>
  )
}

export default AllFeatureSection
